<template>
	<div v-if="requiredProp" class="row pl-3">
		<span class="first-text"> {{ propName }}: {{ requiredProp }} </span>
	</div>
</template>

<script>
export default {
	name: 'OneLineResult',

	props: {
		requiredProp: '',
        propName: '',
	},
}
</script>

<style lang="stylus" scoped>
.first-text
	font-size 20px
</style>



// WEBPACK FOOTER //
// src/components/search_provider/results/OneLineResult.vue